module.exports = __webpack_public_path__ + "cancel.svg?6e766325713ab3612ad71a24b5dff3f1";